import {
    Env,
    FsCrossDashboard,
    FsDashboard,
    RetailDashboard,
} from '../user/userTypes'

export enum Units {
    kg = 'kg',
    uvc = 'UVC',
    liter = "L",
    uvcPerStorePerMonth = 'UVC / PDV / mois',
    literPerMonth = "L / mois",
    uvcPerMonth = "UVC / mois",
    none = '',
    references = 'Références',
    stores = 'Points de vente',
    percent = '%',
    '€/kg' = '€ / kg',
    warehouses = 'Dépôts',
    clients = 'clients',
    kgPerWarehouse = 'kg / dépôt',
    uvcPerWarehouse = 'UVC / dépôt',
    literPerWarehouse = 'L / dépôt',
    uvcPerStore = "UVC / PDV",
    pdv = 'PDV',
    euro = '€',
    kgPerUFPerMonth = "kg / UF / Mois",
    UF = "UF",
    euroPerUF = "€ / UF",
    transactions = "transactions",
    kgPerTransaction = "kg / transaction",
    "€PerTransaction" = "€ / transaction",
    ca = "CA (€)",
    volume = "Volume (UVC)",
    point = "pt",
    hectoLiter = "HL"
}

export interface GlobalState {
    env: Env
    period: PeriodGap
    fsCrossDashboardData: FsCrossDashboard
    fsDashboardData: FsDashboard | null
    retailDashboardData: RetailDashboard | null
    isLoading: boolean
    error: null | string
    unit: Units
    isFiltered: boolean
}

export interface PeriodGap {
    min: string
    max: string
}
